import { createGlobalStyle, css } from 'styled-components';
import {
    fontWeightLight,
    fontWeightRegular,
    fontWeightBold,
    playGrey5,
    fontFamilyRegular,
    fontWeightExtraBold,
} from '../../ui-components/design-tokens';
import { playFontSize } from '../../ui-components/typography/helpers';

const assetPrefix = process.env.ASSET_PREFIX || 'https://www.svtstatic.se/play/play7';

const GlobalStyles = createGlobalStyle`
    html {
        background-color: ${playGrey5};
        height: 100%;

        /* Sets up the Base 10 stuff */
        font-size: 62.5%;
    }

    body {
        background-color: ${playGrey5};
        height: 100%;
        ${playFontSize(1.3)}
        font-family: ${fontFamilyRegular};
    }

    button,
    input {
        font-family: ${fontFamilyRegular};
    }

    img {
        max-width: 100%;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
        /* Reset default values from normalize.css */
        margin: 0;
    }
    

    /* DisplayItalic */
    @font-face {
        font-family: Publik;
        font-weight: ${fontWeightExtraBold};
        font-style: italic;
        font-display: swap;
        src: url("https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-2.0.0/fonts/PublikWeb-DisplayItalic.woff2") format("woff2"),
            url("https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-2.0.0/fonts/PublikWeb-DisplayItalic.woff") format("woff"),
            url("https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-2.0.0/fonts/PublikWeb-DisplayItalic.ttf") format("truetype");
    }


    @font-face {
        font-family: Publik;
        font-weight: ${fontWeightLight};
        font-style: normal;
        font-display: swap;
        src: url('https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Light.woff2')
                format('woff2'),
            url('https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Light.woff')
                format('woff');
    }

    @font-face {
        font-family: Publik;
        font-weight: ${fontWeightRegular};
        font-style: normal;
        font-display: swap;
        src: url('https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Regular.woff2')
                format('woff2'),
            url('https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Regular.woff')
                format('woff');
    }

    @font-face {
        font-family: Publik;
        font-weight: ${fontWeightBold};
        font-style: normal;
        font-display: swap;
        src: url('https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Bold.woff2')
                format('woff2'),
            url('https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Bold.woff')
                format('woff');
    }

    @font-face {
        font-family:"svt-icons";
        src:url("${assetPrefix}/_next/static/media/svt-icons-ffcaed4f35385e677b829905147985b3.cce506698da10ec636dd9889857c6edf.eot");
        font-weight:normal;
        font-style:normal;
    }

    @font-face {
        font-family:"svt-icons";
        src:url("${assetPrefix}/_next/static/media/svt-icons-ffcaed4f35385e677b829905147985b3.cce506698da10ec636dd9889857c6edf.eot");
        src:url("${assetPrefix}/_next/static/media/svt-icons-ffcaed4f35385e677b829905147985b3.cce506698da10ec636dd9889857c6edf.eot?#iefix") format("embedded-opentype"),
            url("${assetPrefix}/_next/static/media/svt-icons-ffcaed4f35385e677b829905147985b3.8fab452bcc82bb309c7a0400655d05f7.woff") format("woff"),
            url("${assetPrefix}/_next/static/media/svt-icons-ffcaed4f35385e677b829905147985b3.64d16286eae1ea80c038b93f994d79fd.ttf") format("truetype"),
            url("${assetPrefix}/_next/static/media/svt-icons-ffcaed4f35385e677b829905147985b3.48256be8e8400a565729c450af4f99a3.svg?#svt-icons") format("svg");
        font-weight:normal;
        font-style:normal;
    }
    
    ${(props) =>
        props.hideOverflow &&
        css`
            body {
                overflow: hidden;
            }
        `}  
`;

export default GlobalStyles;
